import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {SetVideoType} from "./__graphql-types__/index.ts";

export const SET_VIDEO_SETTINGS_MUTATION: GqlOperation<
    SetVideoType["response"],
    SetVideoType["variables"]
> = gqlOp(gql`
    mutation SetVideo(
        $kaid: String!
        $muteVideos: Boolean!
        $showCaptions: Boolean!
        $playbackRate: PlaybackRate!
    ) {
        setSettings(
            kaid: $kaid
            muteVideos: $muteVideos
            showCaptions: $showCaptions
            playbackRate: $playbackRate
        ) {
            user {
                id
                muteVideos
                showCaptions
                playbackRate
            }
            errors {
                code
            }
        }
    }
`);

export default SET_VIDEO_SETTINGS_MUTATION;
